import { render } from "./UploadHomework.vue?vue&type=template&id=22d5a886&scoped=true"
import script from "./UploadHomework.vue?vue&type=script&lang=js"
export * from "./UploadHomework.vue?vue&type=script&lang=js"

import "./UploadHomework.vue?vue&type=style&index=0&id=22d5a886&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d5a886"]])

export default __exports__